import { IonFab, IonFabButton } from '@ionic/react';
import React from 'react';
import { IoLogoWhatsapp } from 'react-icons/io';

const WhatsappFAB = ({
  number,
  coverText,
  className = '',
}: {
  number: string;
  coverText?: string;
  className?: string;
}) => {
  return (
    <IonFab
      slot="fixed"
      className={`!right-5 fixed !size-auto ${className}`}
    >
      <IonFabButton size="small">
        <a
          href={`https://wa.me/${number}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact via WhatsApp"
          className=" flex items-center"
        >
          <span className="size-[25px] flex items-center text-green-600">
            <IoLogoWhatsapp className="size-full" />
          </span>
        </a>
      </IonFabButton>
    </IonFab>
  );
};

export default WhatsappFAB;
